'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct13 from "./scala.-Product13.js";
var $p;
/** @constructor */
function $c_T13(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13) {
  this.mV = null;
  this.n0 = null;
  this.n1 = null;
  this.n2 = null;
  this.n3 = null;
  this.n4 = null;
  this.n5 = null;
  this.n6 = null;
  this.n7 = null;
  this.mW = null;
  this.mX = null;
  this.mY = null;
  this.mZ = null;
  this.mV = _1;
  this.n0 = _2;
  this.n1 = _3;
  this.n2 = _4;
  this.n3 = _5;
  this.n4 = _6;
  this.n5 = _7;
  this.n6 = _8;
  this.n7 = _9;
  this.mW = _10;
  this.mX = _11;
  this.mY = _12;
  this.mZ = _13;
}
export { $c_T13 as $c_T13 };
$p = $c_T13.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T13;
/** @constructor */
function $h_T13() {
}
export { $h_T13 as $h_T13 };
$h_T13.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 13;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct13.$f_s_Product13__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 1224168367, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T13) && (((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mV, x$0.mV) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n0, x$0.n0)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n1, x$0.n1)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n2, x$0.n2)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n3, x$0.n3)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n4, x$0.n4)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n5, x$0.n5)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n6, x$0.n6)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n7, x$0.n7)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mW, x$0.mW)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mX, x$0.mX)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mY, x$0.mY)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mZ, x$0.mZ))));
});
$p.o = (function() {
  return "Tuple13";
});
$p.b = (function() {
  return (((((((((((((((((((((((((("(" + this.mV) + ",") + this.n0) + ",") + this.n1) + ",") + this.n2) + ",") + this.n3) + ",") + this.n4) + ",") + this.n5) + ",") + this.n6) + ",") + this.n7) + ",") + this.mW) + ",") + this.mX) + ",") + this.mY) + ",") + this.mZ) + ")");
});
function $isArrayOf_T13(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eC)));
}
export { $isArrayOf_T13 as $isArrayOf_T13 };
var $d_T13 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T13, "scala.Tuple13", ({
  eC: 1,
  b: 1,
  c: 1,
  rL: 1,
  a: 1
}));
export { $d_T13 as $d_T13 };
